/**
 * <wp-set-selector> — "Packung:" picker for the Packung option (Einzeln vs
 * Set bundle variant; plan 2026-10-05 set-rabatt-variant-bundles).
 * Variant switching is Dawn's: the radios live inside <variant-selects>, which
 * publishes the change and product-info.js swaps the section markup (this
 * element included — connectedCallback re-runs after every swap). This adds:
 * - the "x Sets = y Stück" note under the set row (Menge counts sets; n is
 *   the selected size's set size, data-set on the set radio);
 * - the Einzeln fallback when the newly picked size has no set: the set row
 *   is not rendered, nothing is checked → select Einzeln.
 */
class WpSetSelector extends HTMLElement {
  connectedCallback() {
    if (!this.querySelector('input:checked')) {
      const single = this.querySelector('input:not([data-set])');
      if (single) {
        single.checked = true;
        single.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
    this._ac = new AbortController();
    this.note = this.querySelector('[data-set-note]');
    this.qtyInput = document.querySelector(`#Quantity-Form-${this.dataset.section} .quantity__input`);
    if (!this.note || !this.qtyInput) return;
    this.qtyInput.addEventListener('change', () => this.updateNote(), { signal: this._ac.signal });
    // product-info.js resets the quantity to min on every variant change
    // without a change event — it publishes quantityUpdate instead.
    this.unsubscribe = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.updateNote());
    this.updateNote();
  }

  disconnectedCallback() {
    this._ac?.abort();
    this.unsubscribe?.();
  }

  updateNote() {
    const n = Number.parseInt(this.querySelector('input[data-set]:checked')?.dataset.set, 10);
    const sets = Number.parseInt(this.qtyInput.value, 10) || 0;
    if (!(n >= 2) || sets < 1) {
      this.note.hidden = true;
      return;
    }
    this.note.textContent = `${sets} ${sets === 1 ? 'Set' : 'Sets'} = ${sets * n} Stück`;
    this.note.hidden = false;
  }
}

if (!customElements.get('wp-set-selector')) {
  customElements.define('wp-set-selector', WpSetSelector);
}
